import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import { getImgixImageData } from "@utils";


import {
  DEIPagePrinciplesSectionCardsDIV,
  DEIPagePrinciplesSectionGridDIV,
  DEIPagePrinciplesSectionSECTION,
  DEIPagePrinciplesSectionStripeIMG,
  DEIPagePrinciplesSectionStripeWrapperDIV,
} from './DEIPagePrinciplesSection.styles';

const DEIPagePrinciplesSection = () => (
  <DEIPagePrinciplesSectionSECTION>
    <div className="container">
      <DEIPagePrinciplesSectionGridDIV>
        <div className="column column--2-12-S column--1-13-M column--2-12-L">
          <h2>Our Principles</h2>
        </div>
        <div className="column column--2-12-S column--1-13-M column--2-12-L">
          <DEIPagePrinciplesSectionCardsDIV>
            <div>
              <GatsbyImage
                alt="Icon: abstract angular shape with swoosh"
                image={getImgixImageData(
                  '/images/pages/dei/DEIPage--principles--data.png',
                  80,
                  80 / 64
                )}
              />
              <h4>Follow the data</h4>
              <p className="type--text-L"><a href="https://www.mckinsey.com/business-functions/organization/our-insights/why-diversity-matters">Study</a> after <a href="https://www.bcg.com/en-us/publications/2018/how-diverse-leadership-teams-boost-innovation">study</a> proves diverse teams are more successful. Not only that, but teams that represent our population — and our customers — will have a greater impact. Like any business with big dreams, we measure what matters, set aggressive goals, and hold ourselves accountable. Diversity, equity, and inclusion are certainly no exception.</p>
            </div>
            <div>
              <GatsbyImage
                alt="Icon: abstract triangle shape with squiggle"
                image={getImgixImageData(
                  '/images/pages/dei/DEIPage--principles--proactive.png',
                  80,
                  80 / 64
                )}
              />
              <h4>Be proactive</h4>
              <p className="type--text-L">​​While talent and potential are equally distributed, opportunity is not. We recruit people from under-represented groups to balance the hiring pool, and we strive to reduce <Link to="/blog/unconscious-bias-in-hiring/">unconscious bias</Link> in our hiring practices. Post-hire, everyone has access to employee resource groups, ongoing training/education, and a safe space to be themselves.</p>
            </div>
            <div>
              <GatsbyImage
                alt="Icon: abstract mountains with clouds"
                image={getImgixImageData(
                  '/images/pages/dei/DEIPage--principles--improving.png',
                  80,
                  80 / 64
                )}
              />
              <h4>Keep improving</h4>
              <p className="type--text-L">DEI is a living, breathing thing, and just like any great product or culture, it has to be nurtured. The work is never done. We publish all the numbers to hold ourselves accountable to continuous improvement. There’s always more we can do to build a diverse and inclusive workplace.</p>
            </div>
          </DEIPagePrinciplesSectionCardsDIV>
        </div>
      </DEIPagePrinciplesSectionGridDIV>
    </div>
    <DEIPagePrinciplesSectionStripeWrapperDIV>
      <DEIPagePrinciplesSectionStripeIMG
        alt=""
        image={getImgixImageData(
          '/images/pages/dei/DEIPage--principles-stripe--desktop.png',
          1920,
          1920 / 600
        )}
        role="presentation"
      />
    </DEIPagePrinciplesSectionStripeWrapperDIV>
  </DEIPagePrinciplesSectionSECTION>
);

export default DEIPagePrinciplesSection;
